import dayjs from "dayjs";

export function getCurrentQuarter() {
	const quarter = `${Math.ceil((dayjs().month() + 1) / 4)}`;
	const currentYear = dayjs().year();
	return `Q${quarter}/${currentYear}`;
}
